import "core-js/modules/web.dom-exception.stack.js";
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required } from '@vuelidate/validators';
import PasswordVerify from '@/components/widget/PasswordVerify';
export default {
  name: 'CreditCardForm',
  components: {
    PasswordVerify
  },
  props: {
    billing: {
      type: Object,
      default: () => {
        return null;
      }
    },
    isRegistration: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      verification: {
        open: false,
        payloadRequest: {
          type: 'cc',
          id: 0
        },
        payload: {},
        verified: false
      },
      cc: {
        number: null,
        expiry: null,
        cvc: null
      },
      ccdisabled: false,
      creditcardtype: null,
      cardErrors: {
        cardNumber: null,
        cardExpiry: null,
        cardCvc: null
      },
      cardBrand: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.billing) {
        this.cc.number = 'XXXX-XXXX-XXXX-' + this.billing.last_four;
        this.cc.expiry = this.billing.expmonth + ' / ' + this.billing.expyear;
        this.ccdisabled = true;
        this.creditcardtype = this.billing.creditcardtype;
        this.verification.payloadRequest.id = this.billing.id;
      }
      if (this.isRegistration) {
        this.$v.cc.$touch();
      }
    },
    setCardType(number) {
      this.creditcardtype = this.determineCardBrand(number);
    },
    setCardTypeOnPaste(event) {
      // Accessing the clipboard data directly
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      this.creditcardtype = this.determineCardBrand(pastedData);
    },
    determineCardBrand(cardNumber) {
      if (!cardNumber) return null;
      // Remove all non-digit characters from the number
      const cleanNumber = cardNumber.replace(/\D/g, '');
      if (/^4[0-9]{12}(?:[0-9]{3,6})?$/.test(cleanNumber)) {
        // Visa: Starts with 4, length 13 or 16 (19 rare)
        return 'Visa';
      } else if (/^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/.test(cleanNumber)) {
        // MasterCard: Starts with 51-55 or 2221-2720, length 16
        return 'MasterCard';
      } else if (/^3[47][0-9]{13}$/.test(cleanNumber)) {
        // American Express: Starts with 34 or 37, length 15
        return 'American Express';
      } else if (/^6(?:011|5[0-9]{2}|4[4-9][0-9]|22(?:1(?:2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9(?:[01][0-9]|2[0-5])))[0-9]{12,15}$/.test(cleanNumber)) {
        // Discover: Starts with 6011, 644-649, 65, or 622126-622925, length 16-19
        return 'Discover';
      } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{11}$/.test(cleanNumber)) {
        // Diners Club: Starts with 300-305, 36, or 38, length 14
        return 'Diners Club';
      } else if (/^(?:2131|1800|35(?:2[8-9]|[3-8][0-9]))\d{11,14}$/.test(cleanNumber)) {
        // JCB: Starts with 2131, 1800, or 3528-3589, length 16-19
        return 'JCB';
      }

      // If no match, return null or 'Unknown'
      return null;
    },
    isValidCreditCardNumber(number) {
      if (!number) return false;
      const sanitizedNumber = number.toString().replace(/\D/g, '');
      return this.determineCardBrand(sanitizedNumber) !== null && this.luhnCheck(sanitizedNumber);
    },
    luhnCheck(number) {
      let sum = 0;
      let alternate = false;
      for (let i = number.length - 1; i >= 0; i--) {
        let n = parseInt(number.charAt(i), 10);
        if (alternate) {
          n *= 2;
          if (n > 9) {
            n -= 9;
          }
        }
        sum += n;
        alternate = !alternate;
      }
      return sum % 10 === 0;
    },
    validateCardNumber() {
      this.$v.cc.number.$touch();
      this.cardErrors.cardNumber = null;
      if (!this.isValidCreditCardNumber(this.cc.number)) {
        this.cardErrors.cardNumber = 'Invalid Credit Card Number';
      }
    },
    validateCardExpiry() {
      this.$v.cc.expiry.$touch();
      this.cardErrors.cardExpiry = null;
      if (!this.$cardFormat.validateCardExpiry(this.cc.expiry)) {
        this.cardErrors.cardExpiry = 'Invalid Expiration Date';
      }
    },
    validateCardCVC() {
      this.$v.cc.cvc.$touch();
      this.cardErrors.cardCvc = null;
      if (!this.$cardFormat.validateCardCVC(this.cc.cvc)) {
        this.cardErrors.cardCvc = 'Invalid CVC';
      }
    },
    editCard() {
      this.verification.open = true;
    },
    setPayload(info) {
      this.verification.verified = info.success;
      if (this.verification.verified) {
        this.verification.payload = info.payload;
        if (this.verification.payload.number) {
          this.cc.number = atob(this.verification.payload.number);
          this.ccdisabled = false;
        }
      }
    },
    emitCard(cc, ccdisabled) {
      const info = {
        number: null,
        expmonth: null,
        expyear: null,
        cvc: null,
        creditcardtype: null,
        valid: false,
        cardedit: 1
      };
      info.creditcardtype = this.determineCardBrand(cc.number);
      if (this.isValidCreditCardNumber(cc.number)) {
        info.number = this.cc.number.replace(/\s/g, '');
      }
      if (this.$cardFormat.validateCardExpiry(cc.expiry)) {
        const parts = cc.expiry.replace(/\s/g, '').split('/');
        info.expmonth = +parts[0];
        info.expyear = parts[1].length === 2 ? parts[1] : +parts[1].slice(-2);
      }
      if (this.$cardFormat.validateCardCVC(cc.cvc)) {
        info.cvc = cc.cvc;
      }
      if (info.number !== null && info.expmonth !== null && info.expyear !== null && info.cvc !== null && !this.$v.$invalid) {
        info.valid = true;
      }
      if (ccdisabled) {
        info.cardedit = 0;
      }
      this.$emit('update', info || null);
    }
  },
  watch: {
    cc: {
      deep: true,
      handler(n) {
        this.emitCard(n, this.ccdisabled);
      }
    },
    ccdisabled(n) {
      this.emitCard(this.cc, n);
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    cc: {
      number: {
        required
      },
      expiry: {
        required
      },
      cvc: {
        required
      }
    }
  }
};